module.exports = __webpack_public_path__ + "img/ajobs.63cbbaa1.avif";